{
  "title": "Summon Fey",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a gilded flower worth at least 300 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth a fey spirit. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Fey Spirit stat block. When you cast the spell, choose a mood. Fuming, Mirthful, or Tricksy. The creature resembles a fey creature of your choice marked by the chosen mood, which determines one of the traits in its stat block. The creature disappears when it drops to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, use the higher level wherever the spell’s level appears in the stat block.",
    "Fey Spirit",
    "Small fey",
    "Armor Class: 12 + the level of the spell (natural armor)",
    "Hit Points: 30 + 10 for each spell level above 3rd",
    "Speed: 40 ft.",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "13 (+1)",
    "16 (+3)",
    "14 (+2)",
    "14 (+2)",
    "11 (+0)",
    "16 (+3)",
    "Condition Immunities: charmed",
    "Senses: darkvision 60 ft., passive Perception 10",
    "Languages: Sylvan, understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Actions",
    "Multiattack. The Fey makes a number of attacks equal to half this spell’s level (rounded down).",
    "Shortsword. Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d6 + 3 + the spell’s level piercing damage + 1d6 force damage.",
    "Bonus Actions",
    "Fey Step. The fey magically teleports up to 30 feet to an unoccupied space it can see. Then one of the following effects occurs, based on the fey’s chosen mood.",
    "Fuming. The fey has advantage on the next attack roll it makes before the end of this turn.",
    "Mirthful. The fey can force one creature it can see within 10 feet of it to make a Wisdom saving throw against your spell save DC. Unless the save succeeds, the target is charmed by you and the fey for 1 minute or until the target takes any damage.",
    "Tricksy. The fey can fill a 5-foot cube within 5 feet of it with magical darkness, which lasts until the end of its next turn."
  ],
  "spellLists": ["druid", "ranger", "warlock", "wizard"]
}
